import React, { useState } from "react";
import { Button } from "react-bootstrap";

import type { Message } from "../../hooks/reactQueryHooks/useRequests";
import { BreadcrumbSeparatorIcon } from "../icons";
import { RequestSidebarMessage } from "./RequestSidebarMessage";

interface RequestSidebarResponseProps {
  response: {
    message: Message;
  }[];
}

const RequestSidebarResponse: React.FC<RequestSidebarResponseProps> = ({
  response,
}) => {
  const [current, setCurren] = useState(0);

  const messagesCount = response?.length || 0;

  const handleNextClick = () => {
    if (current < messagesCount - 1) {
      setCurren(current + 1);
    }
  };

  const handlePrevClick = () => {
    if (current > 0) {
      setCurren(current - 1);
    }
  };

  return (
    <>
      <div className="d-flex align-items-center request-sidebar-title">
        <h4>Answer</h4>
        {messagesCount > 1 && (
          <div className="d-flex align-items-center response-controls">
            <Button
              variant="link"
              className="prev-response btn-resp"
              onClick={handlePrevClick}
              disabled={current === 0}
              data-testid="prev-response"
            >
              <BreadcrumbSeparatorIcon />
            </Button>
            <div className="response-counter">
              {`${current + 1}/${messagesCount}`}{" "}
            </div>
            <Button
              variant="link"
              className="next-response btn-resp"
              onClick={handleNextClick}
              disabled={messagesCount - 1 === current}
              data-testid="next-response"
            >
              <BreadcrumbSeparatorIcon />
            </Button>
          </div>
        )}
      </div>
      <RequestSidebarMessage
        message={response[current].message?.content}
        role={response[current].message.role}
      />
    </>
  );
};

export { RequestSidebarResponse };
